//export module Models {
export class AccessTokenJsConstantsCrossModel {
    constructor() {
        this.errorMessage = null;
    }
}
AccessTokenJsConstantsCrossModel.localStorageVariableName = "bplayV2";
AccessTokenJsConstantsCrossModel.clubIdKey = "ci";
AccessTokenJsConstantsCrossModel.roleMaskKey = "rm";
AccessTokenJsConstantsCrossModel.isSystemRoleKey = "isr";
AccessTokenJsConstantsCrossModel.accessTokenKey = "at";
AccessTokenJsConstantsCrossModel.expiresInKey = "ei";
AccessTokenJsConstantsCrossModel.scopeKey = "s";
AccessTokenJsConstantsCrossModel.tokenTypeKey = "tt";
AccessTokenJsConstantsCrossModel.userRolesKey = "ur";
AccessTokenJsConstantsCrossModel.unionClubIdKey = "uci";
AccessTokenJsConstantsCrossModel.webApiUrl = "webApiUrl";
//}
